import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
    unreadMessagesCount: 0,
    unreadMessagesIds: [],
    lastUpdate: null,
    hasAnyMessages: false,
    lastMsgId: 0,
});

function reduce(state = initialState, action = {}) {
    switch (action.type) {
        case types.INBOX_NEW_MONTH_MESSAGES:
            return getStateAfterNewMonthMessages(state, action);
        case types.INBOX_MESSAGES_NEW:
            return getStateAfterNewMessage(state, action);

        case types.INBOX_MESSAGES_READ:
            return getStateAfterReadMessage(state, action);

        case types.INBOX_MESSAGES_PROCESSED_UPDATE:
            return state.merge({ lastUpdate: null });

        case types.INBOX_READ_ALL_MESSAGES:
            return state.merge({
                unreadMessagesCount: 0,
                unreadMessagesIds: [],
            });

        case types.INBOX_FETCH_MESSAGES_SUCCESSFUL:
            return state.merge({
                hasAnyMessages: action.hasAnyMessages,
                unreadMessagesCount: action.unreadMessagesCount,
                unreadMessagesIds: action.unreadMessagesIds,
            });

        default:
            return state;
    }
}

function getStateAfterNewMonthMessages(state, action) {
    const { unreadMessagesIds } = action;
    const lastMsgId = Math.max(unreadMessagesIds);

    return state.merge({
        unreadMessagesCount: unreadMessagesIds.length,
        unreadMessagesIds: unreadMessagesIds,
        lastUpdate: Date.now(),
        hasAnyMessages: true,
        lastMsgId,
    });
}

function getStateAfterNewMessage(state, { messageId = 0 }) {
    const newUnreadMessagesIds =
        messageId && messageId > 0 ? [...state.unreadMessagesIds, messageId] : state.unreadMessagesIds;
        const lastMsgId = Math.max(newUnreadMessagesIds);

        return state.merge({
        unreadMessagesCount: state.unreadMessagesCount + 1,
        unreadMessagesIds: newUnreadMessagesIds,
        lastUpdate: Date.now(),
        hasAnyMessages: true,
        lastMsgId
    });
}

function getStateAfterReadMessage(state, { messageId = 0 }) {
    const newUnreadMessagesIds = state.unreadMessagesIds.filter(id => id !== messageId);

    return state.merge({
        unreadMessagesCount: state.unreadMessagesCount - 1,
        unreadMessagesIds: newUnreadMessagesIds,
    });
}

export default reduce;
